<h2 mat-dialog-title>
    Verify your new email address.
</h2>

<mat-dialog-content>
    <app-code-verification
        #codeVerification
        class="code-verification--modal"
        (verified)="onVerifyCode_closeModal()"
        (resendCode)="data.onCodeSent?.()"
        [email]="data.email"
        [requestType]="requestType"
        [verifiesCode]="true"
        [codeSent]="data.codeSent">
    </app-code-verification>
</mat-dialog-content>

<!-- The dialog opens with disableClose, so Cancel is the only way out short of verifying -->
<mat-dialog-actions align="end">
    <button matButton type="button" [mat-dialog-close]="false">Cancel</button>
    <button matButton type="button"
        (click)="codeVerification.onClick_submit()"
        [disabled]="appService.pageLoading$ | async">
        @if (appService.pageLoading$ | async) {
            <mat-spinner diameter="20"></mat-spinner>
        } @else {
            <span>Verify Email</span>
        }
    </button>
</mat-dialog-actions>
